import { create } from "zustand";
import { devtools } from "zustand/middleware";
import moment from "moment";

const initialState = {
  showDetails: false,
  expandDetails: false,
  filterDrawerOpen: false,
  sideNavCollapsed: false,
  dateRange: {
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    rangeType: "MTD",
  },
  mobileMenuOpen: false,
};

const useCommonStore = create(
  devtools((set) => ({
    ...initialState,
    setShowDetails: (t) => set({ showDetails: t }),
    setExpandDetails: (t) => set({ expandDetails: t }),
    toggleMobileMenu: () =>
      set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),
    setMobileMenuOpen: (s) => set({ mobileMenuOpen: s }),
    toggleShowDetails: () =>
      set((state) => ({ showDetails: !state.showDetails })),
    toggleExpandDetails: () => {
      set((state) => ({ expandDetails: !state.expandDetails }));
    },
    setFilterDrawerOpen: (isOpen) => set({ filterDrawerOpen: isOpen }),
    setSideNavCollapsed: (collapsed) => set({ sideNavCollapsed: collapsed }),
    setDateRange: (range) => set({ dateRange: range }),

    reset: () => set(initialState),
  })),
);

export default useCommonStore;
